import React, { Component } from "react";
import { connect } from "react-redux";

//ACTIONS
import * as ACTIONS from "./../../../actions/actionConstants";

//Deps
import copy from "copy-to-clipboard";

//MUI
import { IconButton, List, ListItem, ListItemText, ListItemSecondaryAction, Switch, Typography } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    clientKey: state.user.currentUser.clientKey,
    darkMode: state.app.darkMode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    //Advanced Form Toggle
    copyClientKey: clientKey => {
      dispatch({
        type: ACTIONS.ACCOUNT,
        meta: {
          filter: "client.copyToClipboard"
        },
        payload: clientKey
      });
    },
    handleToggle: (val, e) => {
      dispatch({
        type: ACTIONS.TOGGLE_DARK_MODE,
        payload: e
      });
    }
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class ClientSettings extends Component {
  render() {
    const { classes, clientKey, copyClientKey, darkMode, handleToggle } = this.props;

    const handleClick = clientKey => {
      copy(clientKey);
      copyClientKey(clientKey);
    };

    return (
      <div className={classes.root}>
        <Typography>client key</Typography>
        <List>
          <ListItem button onClick={() => handleClick(clientKey)}>
            <ListItemText primary={clientKey} secondary="copy to clipboard" />
            <ListItemSecondaryAction>
              <IconButton aria-label="Copy">
                <AddCircleIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>

        <Typography>client settings</Typography>
        <div style={{ paddingBottom: "2em" }}>
          <Switch checked={darkMode} onChange={handleToggle} aria-label="LoginSwitch" /> dark mode
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ClientSettings));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/account_tabs/ClientSettings.js